<template>
  <section id="services">
    <div class="container">
      <div class="row">
        <div class="col-lg-12 text-center">
          <h2 class="section-heading">Features</h2>
          <h3 class="section-subheading text-muted">With Netsix, sharing videos with your friends is fast and simple.<br>
            Once connected in peer-to-peer, you can stream and watch videos stored on a friend's hard drive as fast as possible.<br>
            <a href="https://github.com/mmorainville/netsix/releases/latest" target="_blank">Download Netsix</a>.</h3>
        </div>
      </div>
      <div class="row text-center">
        <div class="col-md-3">
          <span class="fa-stack fa-4x">
            <i class="fa fa-circle fa-stack-2x text-primary"></i>
            <i class="fa fa-fighter-jet fa-stack-1x fa-inverse"></i>
          </span>
          <h4 class="service-heading">Fast</h4>
          <p class="text-muted">Netsix uses WebRTC to create a real peer-to-peer connection.</p>
        </div>
        <div class="col-md-3">
          <span class="fa-stack fa-4x">
            <i class="fa fa-circle fa-stack-2x text-primary"></i>
            <i class="fa fa-laptop fa-stack-1x fa-inverse"></i>
          </span>
          <h4 class="service-heading">Simple</h4>
          <p class="text-muted">Installing and using Netsix is really simple: just download the app and share your ID.</p>
        </div>
        <div class="col-md-3">
          <span class="fa-stack fa-4x">
            <i class="fa fa-circle fa-stack-2x text-primary"></i>
            <i class="fa fa-lock fa-stack-1x fa-inverse"></i>
          </span>
          <h4 class="service-heading">Secure</h4>
          <p class="text-muted">The WebRTC connexion is naturally encrypted and no one can see what you are sharing with your friends.</p>
        </div>
        <div class="col-md-3">
          <span class="fa-stack fa-4x">
            <i class="fa fa-circle fa-stack-2x text-primary"></i>
            <i class="fa fa-rebel fa-stack-1x fa-inverse"></i>
          </span>
          <h4 class="service-heading">Open Source</h4>
          <p class="text-muted">The code is on <a href="https://github.com/mmorainville/netsix" target="_blank">GitHub</a> and you are free to help improve the app.</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  export default {
    name: 'services'
  }
</script>



// WEBPACK FOOTER //
// Services.vue?08a2c884